import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Tooltip } from 'react-leaflet';

import PreviewTile, { PreviewTileProps } from '../../../Shared/preview-tile';

const PreviewTooltip = (props: PreviewTileProps) => {
    return (
        <React.Fragment>
            <StyledTooltip direction="top" sticky={true}>
                <Container>
                    <PreviewTile {...props} />
                </Container>
            </StyledTooltip>
        </React.Fragment>
    );
};

export default PreviewTooltip;

const Container = styled.div`
    height: 48px;
    width: 320px;
    overflow: hidden;
    border-radius: 12px;
`;

const FadeIn = keyframes`
  0%, 25% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const StyledTooltip = styled(Tooltip)<{ direction: string; sticky: boolean }>`
    position: absolute;
    background-color: transparent;
    border: none;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    margin: 0 0 0px 0;
    bottom: -36px;
    padding: 0;

    &:before {
        content: '';
        position: absolute;
        display: block;
        width: 0px;
        left: 50%;
        border: 10px solid transparent;
        border-bottom: 0;
        border-top: 10px solid rgba(0, 0, 0, 0.7);
        transform: translate(-23%, calc(100% - 12px));
        animation: ${(props) => (props ? FadeIn : 'none')} 30ms ease-in-out;
    }
`;
